import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles  } from '@mui/styles';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import { ExpandMore } from '@mui/icons-material';
import { fields } from './fields';
import CopySettingsToolbar from './CopySettingsToolbar';
// import { StackedNotification } from '../StackedNotification';
import SourceSettings from './SourceSettings';
import Datagrid from '../datagrid/DataGrid';
import { GLO_PLACEMENT } from '../../utils/link';
import { isLiveOrder } from '../../utils/adManagerHelpers';
import {toast} from "react-toastify";

const styles = (/* theme */)=> ({
  root: {
    padding: 20
  },
  table: {
    margin: 0
  }
});

const badgeConf = {
  'LIVE': 'error'
};

const columns = [
  { id: 'id', label: 'Id' },
  { id: 'agencyPlacementName', label: 'Agency Name', link: GLO_PLACEMENT, filterable: true },
  { id: 'isLiveOrder', label: 'Is Live', badge: badgeConf },
  { id: 'start', label: 'Start', date: 'YYYY-MM-DD', filterable: true},
  { id: 'end', label: 'End', date: 'YYYY-MM-DD', filterable: true }
];

export class CopySettingsView extends Component {

  state = {
    selected: [],
    checked: {},
    canCopy: false,
    settingsExpanded: true,
    error: ''
  };

  handleComplexFields = (field, isChecked) => {
    const { checked } = this.state;
    if (field.propName === 'CustomCriteriaPresets' && !checked.Strategy) {
      this.props.onStrategyDetails(field, isChecked);
    }
  };

  canCopy = (selected, checked) => {
    const hasChecked = Object.keys(checked).filter(k => checked[k]);
    return selected.length > 0 && hasChecked.length > 0;
  };

  handleDependents = (field, isChecked, checked) => {
    if (field.hasDependent) {
      field.hasDependent.forEach(d => {
        checked[d] = isChecked;
      });
    }
    return checked;
  };

  toggleCheck = (key, field) => () => {
    const { selected } = this.state;
    let { checked } = this.state;
    checked[key] = !checked[key];
    checked = this.handleDependents(field, checked[key], checked);
    const canCopy = this.canCopy(selected, checked);
    this.setState({ checked, canCopy });
    this.handleComplexFields(field, checked[key]);
  };

  selectedPlacements = selected => {
    const { checked } = this.state;
    const canCopy = this.canCopy(selected, checked);
    this.setState({ selected, canCopy });
  };

  isPubMatch = (placement, pubSelect) => {
    if (pubSelect === 'HDM' &&
      (placement.SalesProduct.name.slice(0, 3) === 'HDM' ||
      placement.SalesProduct.name === 'Automotive Consumer Targeting')) {
      return true;
    }
    return pubSelect === 'CDRT' && placement.SalesProduct.name.slice(0, 4) === 'CDRT';
  };

  getRows = () => {
    const { targets, pubSelect } = this.props;
    const { selected, checked } = this.state;
    let filteredTargets = (checked && checked.Pubs && pubSelect) ?
      targets.filter(t => this.isPubMatch(t, pubSelect)) :
      targets;
    filteredTargets = filteredTargets.filter(t => !t.packageId)
    return filteredTargets.map(t => {
      t.$selectedRow = selected.some(p => p.id === t.id);
      t.isLiveOrder = isLiveOrder([t]) ? 'LIVE' : '';
      return t;
    })
  };

  closeSnackbar = () => this.setState({ error: '' });

  copy = () => {
    const { selected, checked } = this.state;
    const targets = selected.map(s => s.id);

    const settings = Object.keys(checked)
      .filter(k => checked[k])
      .map(k => [].concat(...fields).find(f => f.propName === k));

    this.props.onCopy(targets, settings);
  };

  onDetailsToggle = expanded => {
    this.setState({settingsExpanded: expanded});
  };

  render() {
    const { checked, canCopy, settingsExpanded, error } = this.state;
    const { placement, classes, onFilter, onBack } = this.props;
    const [ first, second, third ] = fields;
    const detailsStyle = {
      height: (window.innerHeight - 340) + "px",
      overflowY: "scroll"
    };
    if (error) {
      toast.error(error, { theme: 'colored', toastId: error });
    }

    return (
      <div>
        {/*({error &&
          <StackedNotification
            open={error.length > 0}
            message={error}
            variant="error"
            onClose={this.closeSnackbar}
          />
        })*/}
        <CopySettingsToolbar
          onBack={onBack}
          onCopy={this.copy}
          canCopy={canCopy}
        />
        <div className={classes.root}>
          <Accordion expanded={settingsExpanded}
            onChange={(evt, expanded) => this.onDetailsToggle(expanded)}>
            <AccordionSummary expandIcon={<ExpandMore />}>
              <Typography variant="h6">
                Copy Placement Settings - {placement.agencyPlacementName}
              </Typography>
            </AccordionSummary>
            <AccordionDetails style={detailsStyle}>
              <Grid container direction="column">
                <Grid item>
                  <Grid container direction="row" spacing={5}>
                    <Grid item xs={6}>
                      <SourceSettings
                        fields={first}
                        checked={checked}
                        placement={placement}
                        onCheck={this.toggleCheck}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <SourceSettings
                        fields={second}
                        checked={checked}
                        placement={placement}
                        onCheck={this.toggleCheck}
                      />
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item>
                  <Grid container direction="row">
                    <Grid item xs={12}>
                      <SourceSettings
                        fields={third}
                        checked={checked}
                        placement={placement}
                        onCheck={this.toggleCheck}
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </AccordionDetails>
          </Accordion>
          <div className={classes.table}>
            <Datagrid
              title="Targeted Placements"
              sortColumn="agencyPlacementName"
              columns={columns}
              data={this.getRows()}
              selectable
              sortable
              filterable
              onFilter={onFilter}
              onSelect={this.selectedPlacements}
              showFilterRow
              expanded={!settingsExpanded}
              onToggleExpand={expanded => this.onDetailsToggle(expanded)}
              offsetTop={310}
            />
          </div>
        </div>
      </div>
    )
  }
}

CopySettingsView.defaultProps = {
  placement: {},
  pubSelect: ''
};

CopySettingsView.propTypes = {
  classes: PropTypes.object.isRequired,
  placement: PropTypes.object,
  pubSelect: PropTypes.string
};

export default withStyles(styles)(CopySettingsView);
